import _asyncToGenerator from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.string.trim.js";
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-a7d3b5a2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "select-field"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 选择商品 ");

const _hoisted_3 = {
  key: 0,
  class: "selected-box selected-box--product"
};
const _hoisted_4 = {
  class: "select-field"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 选择业务员 ");

const _hoisted_6 = {
  key: 0,
  class: "selected-box selected-box--salesman"
};
const _hoisted_7 = {
  class: "price-field"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "price-tips"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "price-tip price-tip--warning"
}, "若业务员奖品已存在，奖品价格将以本次编辑的最新价格覆盖"), /*#__PURE__*/_createElementVNode("div", {
  class: "price-tip"
}, "若需支持改价请至团队商品开启改价开关")], -1));

const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定");

import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { savePrizeManage } from '@/request';
import SelectPrizeProductModal from './SelectPrizeProductModal.vue';
import SalesmanModal from '@/views/creditManage/components/salesman-modal.vue';
import PrizeValidFormItem from './PrizeValidFormItem.vue';
export default {
  name: 'AddPrizeModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierOptions: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const formRef = ref();
    const saving = ref(false);
    const productModalVisible = ref(false);
    const salesmanModalVisible = ref(false);
    const selectedProducts = ref([]);
    const selectedSalesmen = ref([]);
    const form = reactive({
      rewardNumber: 1,
      price: 0.01,
      validType: 1,
      validEndDate: ''
    });
    const rules = {
      rewardNumber: [{
        required: true,
        message: '请填写奖励数量',
        trigger: 'blur'
      }, {
        validator: (_rule, value, callback) => {
          if (!value || value <= 0) {
            callback(new Error('奖励数量必须大于0'));
            return;
          }

          callback();
        },
        trigger: 'blur'
      }],
      validType: [{
        validator: (_rule, value, callback) => {
          if (!value) {
            callback(new Error('请选择效期'));
            return;
          }

          if (value === 5 && !form.validEndDate) {
            callback(new Error('请选择自定义截止日期'));
            return;
          }

          callback();
        },
        trigger: 'change'
      }],
      price: [{
        required: true,
        message: '请填写奖品价格',
        trigger: 'blur'
      }, {
        validator: (_rule, value, callback) => {
          if (value === null || value === undefined || value === '') {
            callback(new Error('请填写奖品价格'));
            return;
          }

          if (Number(value) <= 0) {
            callback(new Error('奖品价格必须大于0'));
            return;
          }

          callback();
        },
        trigger: 'blur'
      }]
    };
    const supplierList = computed(() => props.supplierOptions.map(item => ({
      supplier_id: item.supplierId,
      supplier_name: item.supplierName
    })));
    const productDisplayText = computed(() => selectedProducts.value.map(item => {
      const name = item.prodName || item.prodNo;
      const spec = item.prodSpecification ? ` ${item.prodSpecification}` : '';
      return `${name}${spec}`.trim();
    }).join('，'));
    const salesmanDisplayText = computed(() => selectedSalesmen.value.map(item => `${item.linkMan}/${item.supplierName}`).join('，'));
    watch(() => props.modelValue, val => {
      if (val) {
        var _formRef$value;

        selectedProducts.value = [];
        selectedSalesmen.value = [];
        form.rewardNumber = 1;
        form.price = 0.01;
        form.validType = 1;
        form.validEndDate = '';
        (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.clearValidate();
      }
    });

    function handleProductSelect(list) {
      selectedProducts.value = list;
    }

    function handleSalesmanSelect(list) {
      selectedSalesmen.value = list;
    }

    function handleConfirm() {
      return _handleConfirm.apply(this, arguments);
    }

    function _handleConfirm() {
      _handleConfirm = _asyncToGenerator(function* () {
        if (saving.value) {
          return;
        }

        if (!selectedProducts.value.length) {
          ElMessage.warning('请选择商品');
          return;
        }

        if (!selectedSalesmen.value.length) {
          ElMessage.warning('请选择业务员');
          return;
        }

        try {
          var _formRef$value2;

          yield (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 ? void 0 : _formRef$value2.validate();
        } catch (_unused) {
          return;
        }

        saving.value = true;
        savePrizeManage({
          rewardNumber: form.rewardNumber,
          price: form.price,
          validType: form.validType,
          validEndDate: form.validType === 5 ? form.validEndDate : undefined,
          products: selectedProducts.value.map(item => ({
            prodNo: item.prodNo,
            prodName: item.prodName,
            supplierIds: item.supplierIds || []
          })),
          salesmen: selectedSalesmen.value.map(item => ({
            supUserId: item.supUserId,
            supplierId: item.supplierId,
            linkMan: item.linkMan,
            supplierName: item.supplierName
          })),
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data.success) {
            ElMessage.success(data.msg || '操作成功');
            visible.value = false;
            emit('success');
          }
        }).finally(() => {
          saving.value = false;
        });
      });
      return _handleConfirm.apply(this, arguments);
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "新增业务员奖品",
        width: "728px",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: saving.value,
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "100px",
          class: "prize-form"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "选择商品",
            required: ""
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
              class: "select-btn",
              type: "primary",
              plain: "",
              icon: "Plus",
              onClick: _cache[0] || (_cache[0] = $event => productModalVisible.value = true)
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            }), _unref(productDisplayText) ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(productDisplayText)), 1)) : _createCommentVNode("", true)])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "选择业务员",
            required: ""
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
              class: "select-btn",
              type: "primary",
              plain: "",
              icon: "Plus",
              onClick: _cache[1] || (_cache[1] = $event => salesmanModalVisible.value = true)
            }, {
              default: _withCtx(() => [_hoisted_5]),
              _: 1
            }), _unref(salesmanDisplayText) ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(salesmanDisplayText)), 1)) : _createCommentVNode("", true)])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "奖励数量",
            prop: "rewardNumber"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: form.rewardNumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.rewardNumber = $event),
              min: 1,
              max: 99999,
              precision: 0,
              controls: true
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "效期",
            prop: "validType",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(PrizeValidFormItem, {
              "valid-type": form.validType,
              "onUpdate:valid-type": _cache[3] || (_cache[3] = $event => form.validType = $event),
              "valid-end-date": form.validEndDate,
              "onUpdate:valid-end-date": _cache[4] || (_cache[4] = $event => form.validEndDate = $event)
            }, null, 8, ["valid-type", "valid-end-date"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "奖品价格",
            prop: "price"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input_number, {
              modelValue: form.price,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.price = $event),
              min: 0.01,
              max: 999999,
              precision: 2,
              step: 0.01
            }, null, 8, ["modelValue", "min", "step"]), _hoisted_8])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createVNode(SelectPrizeProductModal, {
          modelValue: productModalVisible.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => productModalVisible.value = $event),
          "default-selected": selectedProducts.value,
          onSuccess: handleProductSelect
        }, null, 8, ["modelValue", "default-selected"]), _createVNode(SalesmanModal, {
          modelValue: salesmanModalVisible.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => salesmanModalVisible.value = $event),
          type: "prize",
          "supplier-list": _unref(supplierList),
          "default-selected": selectedSalesmen.value,
          onSuccess: handleSalesmanSelect
        }, null, 8, ["modelValue", "supplier-list", "default-selected"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};